import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
import {
  PerTargetCorrectionPaymentCycleDropDown,
  PerTargetCorrectionPaymentCycleDropDownProps,
} from '../custom_components/TargetCorrectionPaymentCycleDropDown'
import { TargetCorrectionPaymentAllowedYearsDto } from '../../types'

export type TargetCorrectionPaymentsYearsProps = {
  currentAppraisalSeasonYear: number
  targetCorrectionPaymentAllowedYears: TargetCorrectionPaymentAllowedYearsDto
  disabled?: boolean
}

export type InputNumberProps = FormikFieldProps & TargetCorrectionPaymentsYearsProps & Partial<PerTargetCorrectionPaymentCycleDropDownProps>

export const FormikTargetCorrectionPaymentCycleDropDown = ({
  name,
  validate,
  currentAppraisalSeasonYear,
  targetCorrectionPaymentAllowedYears,
  disabled,
  ...restProps
}: InputNumberProps): JSX.Element => (
  <Field name={name} validate={validate}>
    {({ field: { value, name, onBlur }, form: { setFieldValue } }: FieldProps) => (
      <PerTargetCorrectionPaymentCycleDropDown
        currentAppraisalSeasonYear={currentAppraisalSeasonYear}
        targetCorrectionPaymentAllowedYears={targetCorrectionPaymentAllowedYears}
        value={value}
        onChange={(value) => {
          setFieldValue(name, value)
        }}
        onBlur={onBlur}
        disabled={disabled}
        {...restProps}
      />
    )}
  </Field>
)
